/**
 * @generated SignedSource<<f3ce31061615fe76b947269deb5d6c75>>
 * @relayHash 3f5a736f4dd660a89b02a4452e465d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184

import type { ConcreteRequest } from 'relay-runtime';
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type usePublicLinkPageDataProviderPublicLinkPageQuery$variables = {
  pageId: string;
};
export type usePublicLinkPageDataProviderPublicLinkPageQuery$data = {
  readonly publicLinkPage: {
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
    readonly publicLinkUrlPath: string | null;
  } | null;
};
export type usePublicLinkPageDataProviderPublicLinkPageQuery = {
  response: usePublicLinkPageDataProviderPublicLinkPageQuery$data;
  variables: usePublicLinkPageDataProviderPublicLinkPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "concreteType": "PublicLinkPage",
    "kind": "LinkedField",
    "name": "publicLinkPage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pageId"
      },
      {
        "kind": "ScalarField",
        "name": "pageStatus"
      },
      {
        "kind": "ScalarField",
        "name": "publicLinkUrlPath"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f5a736f4dd660a89b02a4452e465d11",
    "id": "d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184",
    "metadata": {},
    "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
    "operationKind": "query",
    "text": "query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath}}"
  }
};
})();

(node as any).hash = "c030204610be720b223484d4a8d871cf";

export default node;
